export default class CreateUpdateRoleRequest {
    name: string = '';
    readThirdPartyAccounts: boolean = false;
    manageThirdPartyAccounts: boolean = false;
    manageThirdPartyPaymentOrders: boolean = false;
    readInstitutionalAccounts: boolean = false;
    manageInstitutionalAccounts: boolean = false;
    manageInstitutionalPaymentOrders: boolean = false;
    readCustomerAccounts: boolean = false;
    manageCustomerAccounts: boolean = false;
    manageCustomerPaymentOrders: boolean = false;
    readLendingAccounts: boolean = false;
    manageLendingAccounts: boolean = false;
    readProducts: boolean = false;
    manageProducts: boolean = false;
    readAccounting: boolean = false;
    manageAccounting: boolean = false;
    readReports: boolean = false;
    manageReports: boolean = false;
    readUsers: boolean = false;
    manageUsers: boolean = false;
    readRoles: boolean = false;
    manageRoles: boolean = false;
    readInstitutionSettings: boolean = false;
    manageInstitutionSettings: boolean = false;
    readAppMediums: boolean = false;
    manageAppMediums: boolean = false;
    readWebhooks: boolean = false;
    manageWebhooks: boolean = false;
}